import { RestApiResponse } from '../../common/rest-api.response';
import { ReferenceItem } from '../reference-item';

export class TaxonomyReferenceItemGetResponse extends RestApiResponse {
    public item: ReferenceItem;

    constructor(data?: Partial<TaxonomyReferenceItemGetResponse>) {
        super(data);
        this.item = data?.item;
    }
}
